import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import { getPositions } from './grid_data';
import { useForm } from 'react-hook-form';
import './grid.css';
import { upsertGridCE } from '../api';
import {MarkdownElement} from "../utils/text";

// https://stackoverflow.com/questions/60713744/how-to-draw-an-arrow-in-svg
// https://stackoverflow.com/questions/6088409/svg-drop-shadow-using-css3
const svg = <svg style={{filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 1))"}} width="35" height="30" viewBox="0 0 35 30">
  <defs>
    <marker id='head' orient="auto" markerWidth='3' markerHeight='3' refX='0.1' refY='1.5'>
      <path d='M0,0 V3 L1.5,1.5 Z' fill="yellow" />
    </marker>
  </defs>

  <path
    id='arrow-line'
    markerEnd='url(#head)'
    strokeWidth='10'
    fill='none' stroke='yellow'  
    d='M0,15 20 15,0 Z'
  />
</svg>

const Positions = ({node, editing, toggleEndPosition, small}) => {
  const { t } = useTranslation();
  const positions = getPositions()

  // check editing
  const start_pos = node.start_position === null ? null : positions[node.start_position];
  const end_pos = node.end_position === null ? null : positions[node.end_position];

  // todo: make a small style
  return <div className={"grid-positions " + (small ? "small" : "")}>
    <div className="container">
      {start_pos && <div className="start-pos" style={{backgroundColor: start_pos.fillColor}}>
	{ t(start_pos.title) }
      </div>}
      {end_pos && <div className="arrow">{ svg }</div>}
      {end_pos && <div className="end-pos" style={{backgroundColor: end_pos.fillColor}}>
	  { t(end_pos.title) }
      </div>}
    </div>
    { editing &&
      <div style={{borderRadius: "5px", border: "1px #ccc solid", display: "inline-flex", padding: "5px 8px", cursor: "pointer", marginTop: "10px"}}>
	{ end_pos && <div onClick={() => toggleEndPosition(false)}>{ t("Remove the target position") }</div>}
	{ !end_pos && <div onClick={() => toggleEndPosition(true)}>{ t("Add a target position") }</div>}
      </div>
    }
  </div>
}

function Panel({contact_node, entity_node, borderColor, onEdit, onBack, acl}) {
  const { t } = useTranslation();

  const image = contact_node ? contact_node.poi_contact.img : entity_node.poi_entity.img;
  const node = contact_node || entity_node;

  const trad_levels = {
    primary: t("Primary actor"),
    secondary: t("Secondary actor"),
  };

  return <div className="grid-panel-ro">
    <div style={{display: "flex", justifyContent: "center"}}>
      <div style={{flex: "1 1 0"}} />
      <img src={ image } />
      <div className="c-img_buttons grid-img_buttons">
	<span style={{padding: "10px", marginTop: "2px", marginRight: "5px"}} className="c-button_bar-back-icon" onClick={onBack}></span>

	{ acl.can_user_edit_grid &&
	<span class="c-button_edit" onClick={onEdit} style={{padding: "14px", marginRight: 0}}></span> }
      </div>
    </div>

    <div className="grid-panel_presentation">
      <div className="grid-panel_label">{ node.label }</div>
      <div className="grid-panel_role">{ node.role }</div>
    </div>

    {
      <div>
	{ trad_levels[node.level] }
      </div>
    }

    {
      node.target && <div>
	{ t("Targetted actor") }
      </div>
    }

    { node.information && <>
      <h4 style={{marginBottom: "10px"}}>{ t("Informations") }</h4>
      <div style={{padding: "10px", border: "1px #ccc solid", borderRadius: "5px", textAlign: "left"}}>
	<MarkdownElement text={node.information} />
      </div>
      </>
    }

    <Positions node={node} />

    { node.objective && <>
	<h4 style={{margin: "10px 0"}}>{ t("Objective") }</h4>
	<div style={{padding: "10px", border: "1px #ccc solid", borderRadius: "5px", textAlign: "left"}}>
	  <MarkdownElement text={node.objective} />
	</div>
      </>
    }

  </div>
}

function PanelEdit({
  node, coords, type, borderColor, theme_id,
  toggleEndPosition, cancelEdition, onDelete, onSubmitSuccess
}) {
  const { t } = useTranslation();

  const image = type == "contact" ? node.poi_contact.img : node.poi_entity.img;

  const trad_levels = {
    primary: t("Primary actor"),
    secondary: t("Secondary actor")
  };

  const {
    register, handleSubmit, setValue, getValues, formState: { errors },
    watch
  } = useForm({ values: coords, defaultValues: node });

  // const watchLevel = watch("level", getValues("level") || node.level);
  const [watchLevel, setWatchLevelState] = useState(node.level);
  const [watchTarget, setWatchTarget] = useState(node.target);

  const setWatchLevel = (e) => { setWatchLevelState(e.target.value) }

  const onSubmit = (e) => {
    e.preventDefault();
    const error_msg = t("An error occured: the grid could not be updated");

    const cb = handleSubmit((data) => {
      upsertGridCE(
	theme_id, type, node.poi_contact_id || node.poi_entity_id, data
      ).then(response => {
        if (response.result == "ok") {
	  onSubmitSuccess();
        } else {
          alert(error_msg);
        }
      }).catch(e => {
        alert(error_msg);
        return e;
      })
    });

    cb();
  }

  return <form className="grid-panel-edit" style={{padding: "0 20px"}} onSubmit={onSubmit}>
    <div style={{display: "flex", justifyContent: "center"}}>
      <div style={{flex: "1 1 0"}} />
      <img src={ image } />
      <div style={{flex: "1 1 0", textAlign: "right", display: "inline-flex", alignItems: "flex-start", justifyContent: "flex-end"}}>
	<div
	  className="c-button"
	  style={{border: "1px #ccc solid", padding: "5px 8px", borderRadius: "5px"}}
	  onClick={cancelEdition}>
	  { t("Cancel") }
	</div>
      </div>
    </div>

    <div style={{display: "flex", justifyContent: "center", width: "100%", gap: "20px"}}>
      <div>
	{ t("Label") }
	<div className="c-grid text">
	  <input type="text" className="input" {...register("label", {required : true})}/>
	</div>
      </div>
      <div>
	{ t("Role") }
	<div className="c-grid text">
	  <input type="text" className="input" {...register("role", {required : true})}/>
	  {errors.role && <div className="c-errors" style={{fontSize: "14px", margin: "4px 0"}}>
	    {t('A role is required')}
	    </div>}
	</div>
      </div>
    </div>

    <div style={{display: "flex", width: "100%", gap: "20px"}}>
    {
      <div className="levels" style={{flex: "1 1 50%"}}>
	<label className={"level " + (watchLevel === "primary" ? "active" : "")}>
	  { t("Strategic") }
	  <input
	    {...register("level", { required : true, value: watchLevel, onChange: setWatchLevel})}
	    type="radio" value="primary" />
	</label>
	<label className={"level " + (watchLevel === "secondary" ? "active" : "")}>
	  { t("Secondary") }
	  <input
	    {...register("level", { required : true, value: watchLevel, onChange: setWatchLevel})}
	    type="radio" value="secondary" />
	</label>
      </div>
    }

    {
      <label className="c-grid" style={{display: "inline-flex", alignItems: "center", flex: "1 1 50%"}}>

	<span style={{marginRight: "5px"}}>{ t("Targetted actor") }</span>

	<input
	  type="checkbox" className="checkbox"
	  {
	    ...register("target", {
	      required: false,
	      onChange: (e) => {
		// if not targetted, no end position
		if (e.target.checked === false) {
		  toggleEndPosition(false)
		}
		setWatchTarget(e.target.checked)
	      }
	    })
	  }
	/>
      </label>
    }
    </div>

    <div style={{display: "flex"}}>
      <input type="hidden" className="input" {...register("start_coord.0", {required: false})}/>
      <input type="hidden" className="input" {...register("start_coord.1", {required: false})}/>
      <input type="hidden" className="input" {...register("end_coord.0", {required: false})}/>
      <input type="hidden" className="input" {...register("end_coord.1", {required: false})}/>
    </div>

    {
    /* warning we pass coords here...
     * Only show edition when target is enabled (no target does not have a right to get an end position)
     * */
    }
    <Positions node={coords} editing={watchTarget} toggleEndPosition={toggleEndPosition} />


    <div style={true && {} || {border: "1px #ccc solid"}}>
      <h3>{ t("Informations") }</h3>
      <div className="c-grid text">
	<textarea {...register("information", {required: false})}>
	</textarea>
      </div>
    </div>

    <div style={true && {} || {border: "1px #ccc solid"}}>
      <h3>{ t("Objective") }</h3>
      <div className="c-grid text">
      <textarea {...register("objective", {required: false})}>
      </textarea>
      </div>
    </div>

    <div style={{display: "flex", justifyContent: "space-between", marginTop: "20px"}}>
      <div>
	<button type="button" className="c-button" style={{backgroundColor: "red", color: "white"}} onClick={onDelete}>
	  { t("Delete") }
	</button>
      </div>
      <div>
	<input type="submit" value={t('Save')} className="c-button publish" />
      </div>
    </div>
  </form>
}

export { Panel, PanelEdit, Positions };
